<span [class.hide-footer]="shouldHideFooter()">
  <rd-anz-info-panel-accordion></rd-anz-info-panel-accordion>
  <footer aria-label="footer" class="footer" data-analytics-nav="footer">
    <div class="footer-container">
      <div class="links">
        <a [routerLink]="contactUsUrl" class="link-item focus-link">{{
          'wl.anz.footer.contact_us' | translate
        }}</a>
        <a [routerLink]="faqsUrl" class="link-item focus-link">{{
          'wl.anz.footer.faqs' | translate
        }}</a>
        <a [routerLink]="tncsUrl" class="link-item focus-link">{{
          'wl.anz.footer.terms_of_use' | translate
        }}</a>
        <a [routerLink]="privacyPolicyUrl" class="link-item focus-link">{{
          'wl.anz.footer.privacy_policy' | translate
        }}</a>
        <a
          [href]="whistleBlowerUrl"
          class="link-item focus-link"
          rel="noopener"
          target="_blank">
          {{ 'wl.anz.footer.whistleblower' | translate }}
        </a>
        <a
          [href]="websiteUrl"
          class="link-item focus-link"
          rel="noopener"
          target="_blank">
          {{ 'wl.anz.footer.website' | translate }}
        </a>
      </div>
      <div class="footer-info">
        <p
          [innerHTML]="'wl.anz.footer.info' | translate"
          class="footer-info-text"></p>
      </div>
      <div class="copyright-info">
        <p class="copyright-info-text">
          {{ 'wl.anz.footer.copyright-info' | translate }}
        </p>
      </div>
    </div>
  </footer>
  <div class="bottom-line"></div>
</span>
